"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskModels = void 0;
const task_model_1 = __importDefault(require("./task.model"));
exports.TaskModels = [
    task_model_1.default,
];
